<template>
	<div>
		<header class="page-title">
			<h2>Summary Settings Editor</h2>
		</header>
		<list-renderer :id="'summarySettingsLister'" :apiUrl="'/api/' + $selectedSite.slug + '/provider-types/summarysettings'" :filterIn="filterIn" :listInData="'summaries'" :listType="'general'" :orderBy="orderBy" :orderByRules="orderByRules" :showOnly="showOnly" :limit="'25'" :additionalFilters="additionalFilters">
			<template #header="{title}">
			</template>
			<template #content='{list}'>
				<div class="table-lister table-responsive">
					<table class="comments">
						<thead>
							<tr>
								<th>Provider Type</th>
								<th>Summary</th>
								<th>Feature group</th>
								<th>Languages</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in list">
								<td>{{ item.provider_type }}</td>
								<td>{{ item.summary }}</td>
								<td>{{ item.default }}</td>
								<td class="nowrap">
									<ul class="translation-languages">
										<li :class="[checkTranslation(item,language) === true ? 'badge-success' : 'badge-danger']"
											:title="[checkTranslation(item,language) === true ? 'Translation in place' : 'Missing translation']"
											class="badge"
											v-for="language in availableLanguages"
											v-if="!selectedAdditionalFilters.hasOwnProperty('languages') || selectedAdditionalFilters.hasOwnProperty('languages') && selectedAdditionalFilters.languages === language.locale"
										>
											{{ language.locale }}
										</li>
									</ul>
								</td>

								<td class="nowrap">
									<a @click="editGroup(item)" class="btn btn-icon btn-primary" title="Edit" v-show="userRoles.includes('site_content.update')"><i class="fas fa-fw fa-pencil-alt"></i></a>
									<a @click="deleteGroup(item)" class="btn btn-icon btn-danger" title="Delete" v-show="userRoles.includes('site_content.delete') && !userRoles.includes('users.translator')"><i class="fas fa-fw fa-trash"></i></a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</template>
		</list-renderer>

		<div class="modal-bg" v-if="translationModal && selectedGroup.id !== null">
			<div class="modal">
				<header class="modal-header">
					<h4 class="modal-title">Edit Translations</h4>
					<a class="modal-close" title="Close modal" @click.prevent="closeTranslationModal"><i class="fas fa-times"></i></a>
				</header>
				<section class="modal-body">
					<div class="card mb-0">
						<header class="card-header language-list">
							<lang-selector></lang-selector>
						</header>
						<div class="card-body">
							<div class="form-group">
								<label for="trans">Translation</label>
								<input id="trans" type="text" v-model="selectedGroup[clickedLang]">
							</div>
						</div>
					</div>
				</section>
				<footer class="modal-footer">
					<a class="btn btn-md btn-success" @click="saveGroup"><i class="fas fa-check"></i> Save</a>
				</footer>
			</div>
		</div>

	</div>
</template>

<script>
import {eventBus} from "../../app";
import modal from "../Modal/DefaultModal.vue";
import VueSelect from '../../../../node_modules/vue-select';
import Errors from '../../Utils/Errors.js';

export default {
	components: {
		modal,
		VueSelect
	},
	props: {
		dataShowOnly: {
			type: Object
		},
		dataEndpoint: {
			type: String
		},
		dataUrlParams: {
			type: Object,
			required: false
		},
		dataSelectedSite: {
			type: Object
		}
	},

	data() {
		return {

			userRoles: this.$currentUserRoles,
			filterIn: ['provider_type', 'summary', 'default'],
			orderBy: ['provider_type', 'summary', 'default'],
			orderByRules: ['asc', 'asc', 'asc'],
			showOnly: typeof this.dataShowOnly !== 'undefined' && Object.keys(this.dataShowOnly) > 0 ? this.dataShowOnly : {},
			timestamp: Math.floor(Date.now() / 1000),
			additionalFilters: {

				languages: {
					elements: this.$availableLanguages,
					elementsValue: 'locale',
					elementsLabel: 'title',
					width: 2,
					filterIn: null,
					default: null,
					orderBy: ['title'],
					orderByRules: ['asc'],
				}
			},
			selectedAdditionalFilters: {},

			availableLanguages: this.$availableLanguages,
			isEditModalVisible: false,
			clickedLang: this.$defaultLanguage.locale,

			groups: [],
			translationList: [],


			translationModal: false,
			selectedGroup: {
				id: null
			},

			errors: new Errors(),
		}
	},

	created() {
		let vm = this;

		eventBus.$on('setActiveStatus', function (clickedLang) {
			vm.clickedLang = clickedLang;
		});

		eventBus.$on('listRendererData', function (data) {
			vm.processListRendererData(data);
		});

		eventBus.$on('additionalFilterChange', function (name, filter, value) {
			vm.additionalFilterChange(name, filter, value);
		});

	},

	methods: {

		additionalFilterChange(name, filter, value) {
			if (value === null) {
				Vue.delete(this.selectedAdditionalFilters, name);
			} else {
				this.selectedAdditionalFilters[name] = value;
			}
		},
		processListRendererData: function (data) {
			if (data.hasOwnProperty('groups')) {
				this.groups = data.groups;
			}
		},

		editGroup: function (group) {
			this.selectedGroup = group;
			eventBus.$emit('pushActiveStatus', this.$defaultLanguage);
			this.clickedLang = this.$defaultLanguage.locale;
			this.translationModal = true;
		},
		saveGroup: function () {
			let vm = this;
			axios.post('/api/' + vm.$selectedSite.slug + '/provider-types/savegroup', vm.selectedGroup)
					.then(response => {
						this.$toastr.success('New translation saved.');
						vm.closeTranslationModal();
					})
					.catch(e => {
						this.errors.record(e.response.data);
						this.$toastr.error('Save new translation failed.', 'Error');
					});
		},
		closeTranslationModal: function () {
			let options = {
				keepPage: true
			}
			eventBus.$emit('listRenderer-fetch', options);
			this.translationModal = false;
			this.clickedLang = this.$defaultLanguage.locale;
		},
		deleteGroup: function (group) {
			let vm = this;
			axios.delete('/api/' + vm.$selectedSite.slug + '/provider-types/' + vm.selectedGroup.provider_type_id + '/deleteSetting/' + vm.selectedGroup.id)
					.then(response => {
						let options = {
							keepPage: true
						}
						eventBus.$emit('listRenderer-fetch', options);
						this.$toastr.success('Summary settings deleted successfully.');
					})
					.catch(e => {
						this.errors.record(e.response.data);
						let options = {
							keepPage: true
						}
						eventBus.$emit('listRenderer-fetch', options);
						this.$toastr.error('Summary settings delete failed.', 'Error');
					});
		},
		checkTranslation(item, language) {
			let locale = language.locale
			return item.hasOwnProperty(locale) && item[locale] !== null && typeof item[locale] !== 'undefined' && item[locale] !== null && item[locale] !== 'null' && item[locale] !== '';
		}
	}
}
</script>

<style>
.important.translation {
	color: #E6393;
}
</style>
